import { QueryBuilderInstrumentsTypes } from "../features/data-wrangler/types/QueryBuilderInstrumentTypes";

const MapWizardToQuery = (wizardConfig: any, selectedAges: any, selectedConstructs: any, selectedInstruments: any, selectedOperators: any) => {
    const visits: string[] = [];
    wizardConfig.ageGroups.forEach((group: any) => {
        if (selectedAges.includes(group.label)) {
            visits.push(group.label);
        }
    });

    const query: any = {
        Fields: {},
        Operators: selectedOperators,
        Conditions: {
            activeOperator: "0",
            children: []
        }
    };

    if (selectedConstructs.length === 0) {
        query.Conditions.children.push({
            field: 'visit_count',
            instrument: 'visit',
            operator: '',
            value: 'atLeast',
            visits: visits
        });
    }
    let intersectCheck: any = [];
    selectedConstructs.forEach((construct: string) => {
        let instruments: string[] = [];
        let field: string = '';
        const mappedConstruct: any = construct;
        instruments = Object.keys(wizardConfig.constructs[construct] || {});
        field = 'construct_count';
        intersectCheck = instruments;

        const intersect = intersectCheck.filter((instrument: string) => selectedInstruments.includes(instrument));
        if (intersect.length === 0) {
            const nonDemographic = instruments.filter((inst: string) => inst !== 'demo');
            if (nonDemographic.length > 0) {
                query.Conditions.children.push({
                    field: field,
                    instrument: 'visit',
                    operator: mappedConstruct,
                    value: 'atLeast',
                    visits: visits
                });
            }
        }
    });

    selectedInstruments.forEach((instrument: string) => {
        if (instrument !== 'demo') {
            query.Conditions.children.push({
                field: wizardConfig?.allInstruments[instrument]?.staticInstrument ? QueryBuilderInstrumentsTypes.StaticInstrument : QueryBuilderInstrumentsTypes.Instrument,
                instrument: 'visit',
                operator: [instrument],
                value: 'atLeast',
                visits: visits
            });
        }
    });

    return query;
}

export default MapWizardToQuery;